import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { IconV2 } from "../../icon_v2";
import CollapseGroupButton from "./CollapseGroupButton";
const CollapseGroup = ({ collapsed, collapseGroup, expandGroup, label, selectedOptions = 0, totalOptions = 0, onChange, optionSelected, }) => {
    const list = Array.isArray(optionSelected)
        ? optionSelected
        : [];
    const groupItems = list.filter((opt) => (opt === null || opt === void 0 ? void 0 : opt.groupLabel) === label);
    const readOnlyGroup = groupItems.length > 0 && groupItems.every((opt) => opt === null || opt === void 0 ? void 0 : opt.isDisabled);
    const handleOnRemove = () => {
        const newVals = list.filter((opt) => opt.groupLabel !== label);
        const removedValues = list.filter((opt) => opt.groupLabel === label);
        onChange(newVals, {
            action: "deselect-option",
            removedValues,
            option: {
                value: `remove-eco-group-${label}`,
                label,
            },
        });
    };
    const countText = readOnlyGroup
        ? `(${totalOptions})`
        : `(${selectedOptions}/${totalOptions})`;
    return (_jsxs("div", { className: "flex flex-row gap-1 py-1", children: [_jsx(CollapseGroupButton, { label: label, collapseGroup: collapseGroup, expandGroup: expandGroup, collapsed: collapsed }), _jsxs("div", { className: "text-primaryText dark:text-dark-primaryText flex-none", children: [label, " ", countText] }), _jsx("div", { className: "text-primaryText dark:text-dark-primaryText mx-1 block flex size-4 min-w-[16px] items-center justify-center rounded-full", onClick: () => handleOnRemove(), role: "button", tabIndex: 0, "aria-label": `remove-all-from-${label.toLowerCase()}`, children: _jsx(IconV2, { type: "fa", icon: {
                        icon: ["far", "circle-xmark"],
                        fixedWidth: true,
                    } }) })] }));
};
export default CollapseGroup;
